<template>
    <v-dialog
        v-model="showSessionExpiringDialog"
        width="40vw"
        height="600px"
        color="darkgreen"
        persistent
    >
        <v-card>
            <v-toolbar color="darkgreen">
                <v-toolbar-title style="color: white">
                    Your session is about to expire
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon theme="dark" @click="closeSessionExpiringDialog">
                    <v-icon icon="$close" />
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <br />
                You will be logged out at {{ sessionExpiresAt }}.
                <br />
                <v-btn color="primary" @click="refreshSession" variant="text">Click here</v-btn> to
                stay logged in.
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from "vue";

import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    methods: {
        ...mapActions(["logout", "refreshSession", "closeSessionExpiringDialog"]),
    },

    computed: {
        ...mapGetters(["showSessionExpiringDialog", "sessionExpiresAt"]),
    },
});
</script>
